import { Injectable } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import Inputmask from 'inputmask'

class TextMasks {
  public readonly usPhone: Inputmask.Options = {
    regex: String.raw`\([1-9]\d{2}\) \d{3}-\d{4}`
  }
  public readonly taxId: Inputmask.Options = {
    regex: String.raw`\d{2}-\d{7}`
  }
  public readonly npi: Inputmask.Options = {
    regex: String.raw`\d{10}`
  }
  public readonly zipCode: Inputmask.Options = {
    mask: '99999[-9999]',
    greedy: false
  }
  public readonly leadingZeros = (numDigits: number) => {
    return {
      mask: '9'.repeat(numDigits),
      placeholder: '0',
      numericInput: true
    } as Inputmask.Options
  }
}

class AppConstants {
  public readonly masks: TextMasks = new TextMasks()
}

@Injectable()
export class UtilService {
  public readonly constants: AppConstants = new AppConstants()

  public getDefaultDateTimeOptions(
    onlyPast = true,
    onlyFuture = false,
    useCurrent = true,
    canClear = true,
    showToday = true
  ): any {
    let result: any = {
      format: 'MM/DD/YYYY LT',
      useCurrent,
      sideBySide: true,
      showTodayButton: showToday,
      showClear: canClear
    }

    if (onlyPast) {
      result = Object.assign({ maxDate: new Date().setHours(23, 59, 59, 0) }, result)
    }
    if (onlyFuture) {
      result = Object.assign({ minDate: new Date().setHours(0, 0, 0, 0) }, result)
    }

    return result
  }

  public getDefaultDateOptions(
    onlyPast = true,
    onlyFuture = false,
    useCurrent = true,
    canClear = true,
    showToday = true
  ): any {
    let result: any = {
      format: 'MM/DD/YYYY',
      useCurrent,
      showTodayButton: showToday,
      showClear: canClear
    }

    if (onlyPast) {
      result = Object.assign({ maxDate: new Date().setHours(23, 59, 59, 0) }, result)
    }
    if (onlyFuture) {
      result = Object.assign({ minDate: new Date().setHours(0, 0, 0, 0) }, result)
    }

    return result
  }

  public getDefaultTimeOptions(
    onlyPast = false,
    onlyFuture = false,
    useCurrent = true,
    canClear = false,
    showToday = false
  ): any {
    let result: any = {
      format: 'LT',
      useCurrent,
      sideBySide: true,
      showTodayButton: showToday,
      showClear: canClear
    }

    if (onlyPast) {
      result = Object.assign({ maxDate: new Date().setHours(23, 59, 59, 0) }, result)
    }
    if (onlyFuture) {
      result = Object.assign({ minDate: new Date().setHours(0, 0, 0, 0) }, result)
    }

    return result
  }

  public getErrorString(response: HttpErrorResponse): string {
    let msg: string = response.toString()
    if (!response.error) {
      return msg
    }

    const err: any = response.error.error
    if (err.message) {
      msg = err.message
    }
    if (err.innererror && err.innererror.message) {
      msg = err.innererror.message
    }
    return msg
  }

  public sanitizePhoneNumber(phoneNumber: string) {
    if (!phoneNumber || phoneNumber.length === 0) {
      return
    }
    return phoneNumber.replace(/[^+\d]+/g, '').trim()
  }
}
